import { carouselItems } from '@/mocks/homeData';

const imageUrls: Record<string, string> = {
  'carousel-01': 'https://readdy.ai/api/search-image?query=A%20retrospective%20year%20in%20review%20editorial%20design%20with%20warm%20golden%20and%20terracotta%20tones%2C%20abstract%20collage%20of%20news%20headlines%20and%20vibrant%20geometric%20shapes%20representing%20major%20events%2C%20magazine%20layout%20style%20with%20clean%20typographic%20elements%20and%20soft%20gradients%2C%20sophisticated%20visual%20storytelling&width=960&height=540&seq=carousel-01&orientation=landscape',
  'carousel-02': 'https://readdy.ai/api/search-image?query=A%20mysterious%20investigative%20journalism%20theme%20with%20dramatic%20lighting%20and%20deep%20amber%20shadows%2C%20abstract%20composition%20with%20magnifying%20glass%20motif%20and%20document%20textures%2C%20warm%20color%20palette%20with%20terracotta%20and%20cream%20accents%2C%20editorial%20photography%20style%20with%20cinematic%20mood&width=960&height=540&seq=carousel-02&orientation=landscape',
  'carousel-03': 'https://readdy.ai/api/search-image?query=A%20modern%20news%20aggregation%20concept%20with%20multiple%20information%20streams%20converging%2C%20abstract%20network%20visualization%20in%20warm%20orange%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20design%20with%20geometric%20nodes%20and%20connections%2C%20sophisticated%20editorial%20layout%20aesthetic&width=960&height=540&seq=carousel-03&orientation=landscape',
  'carousel-04': 'https://readdy.ai/api/search-image?query=A%20curated%20collection%20of%20top%20stories%20presented%20in%20a%20magazine%20spread%20style%2C%20warm%20ambient%20lighting%20with%20soft%20shadows%2C%20abstract%20arrangement%20of%20cards%20and%20badges%20in%20terracotta%20and%20peach%20tones%2C%20elegant%20editorial%20design%20with%20sophisticated%20visual%20hierarchy&width=960&height=540&seq=carousel-04&orientation=landscape',
};

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            精选专题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-600 mt-2">编辑精选的深度专题内容，全方位解读热点事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer group"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={imageUrls[item.imageSeq]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold bg-primary-500 text-background-50 px-2 py-0.5 rounded">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}